import React from 'react';
import Box from '@mui/material/Box';
import {type Property} from 'csstype';

import {Text} from '../text';
import {type ListBreakpoint, useListMediaQuery} from './use-list-media-query';
import {ClassNames} from './shared';

export type ListHeaderItemProps = {
    title?: string;
    textAlign?: Property.TextAlign;

    /**
     * @default 'tabletPortrait'
     */
    displayFrom?: ListBreakpoint;
};

export const ListHeaderItem = (props: ListHeaderItemProps) => {
    const {title, displayFrom = 'tabletPortrait'} = props;

    const isVisible = useListMediaQuery(displayFrom);

    return (
        <Box className={ClassNames.ListHeader} px={4} display={isVisible ? 'inline-flex' : 'none'}>
            <Text variant="body-small" emphasized textAlign={props.textAlign} width="100%">
                {title}
            </Text>
        </Box>
    );
};
